/**
 * @generated SignedSource<<31157018b8810b515d3c28cf2a3f1ea0>>
 * @relayHash a66ee5034d31979f751369e5899ed372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3dfde4445b96a2a06d0d8e23929faaec99e251c964ffa8aa87744d316f220cf

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d3dfde4445b96a2a06d0d8e23929faaec99e251c964ffa8aa87744d316f220cf",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
